interface UseAllowCodeDownload {
  allowCodeDownload: boolean
}

// TODO: delete this hook
export function useAllowCodeDownload(): UseAllowCodeDownload {
  return {
    allowCodeDownload: true
  }
}
